// removed by extract-text-webpack-plugin
module.exports = {"root":"agency__root--s5p-E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/screens/Agency/agency.css
// module id = mQ3b
// module chunks = 0